import React, { useState, useEffect } from "react";
// react plugin for creating charts
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import { useSelector , useDispatch } from "react-redux";
// core components
// import Button from "components/CustomButtons/Button.js";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { formatDate } from "utils/Utils";
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import LoanReject from "views/admin/components/LoanReject";
import { endpoint } from "assets/api/endpoint";
import Marquee from "react-fast-marquee";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { saveUserDetails } from "store/reducers/UserDetails/UserDetailsSlice";
import { Button, Grid } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import brandTheme from "brandTheme/Theme";
import ToastModal from "views/components/ToastModal";
import { parseAndSetFlag } from "utils/Utils";
const useStyles = makeStyles(styles);

export default function Dashboard({seletedBranchCode, featureFlags}) {
  const classes = useStyles();

  const [selectedTableData, setSelectedTableData] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [tableColumns, setTableColumns] = useState([
    { id: "LoanRequestNum", label: "Loan Request Num" },
    { id: "ProposedLoanAmt", label: "Proposed Loan Amt" },
    { id: "Created", label: "Created Date" },
    { id: "Select", label: "Select Agent" },
    { id: "Actions", label: "Actions" },
  ]);
  const [completeAgentList, setCompleteAgentList] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState({});
  const [selectedAgents, setSelectedAgents] = useState({});
  const [showLoanDetails, setShowLoanDetails] = useState(false);
  const [loanDetails, setLoanDetails] = useState({});
  const [showLoanReject, setShowLoanReject] = useState(false);
  const [loanReject, setLoanReject] = useState({});
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const { userDetails } = useSelector((state) => state.userDetail.userDetails);
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [goldRate, setGoldRate] = useState([]);
  const dispatch = useDispatch()
  const branchCodeSend = seletedBranchCode ? seletedBranchCode : userDetails?.branchCode;
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const closeLoanModal = () => {
    setShowLoanDetails(false);
    setLoanDetails({});
  };

  const closeLoansModal = () => {
    setShowLoanReject(false);
    setLoanReject({});
    GetDashboardData();
  };

  useEffect(()=>{
    if(branchCodeSend){
    GetDashboardData();}
  },[branchCodeSend])
  const GetDashboardData = async () => {
    const agentList = await apiHandler({
      url: endpoint.ADMIN_USER_AGENTS,
      authToken: authToken,
    });
    setCompleteAgentList(agentList?.data);
    const result = await apiHandler({
      url: endpoint.ADMIN_FINDBYBRANCHID + branchCodeSend,
      authToken: authToken,
    });
    setRawData(result.data);
    parseIndicatorData(result.data, agentList.data);
  };
  const parseIndicatorData = (data, agentList) => {
    let reportData = [];
    data &&
      data.applications &&
      data.applications.forEach((goldpay, index) => {
        let row = {
          LoanRequestNum: getLink(goldpay.id, goldpay.loanRequestNum),
          ProposedLoanAmt: goldpay.proposedLoanAmt,
          Created: formatDate(goldpay.createdOn),
          Select: createdFeildagent(goldpay.id, agentList),
          Actions: getIcons(goldpay.id),
        }
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
  const getLink = (loanApplicationId, link) => {
    return link !== "" ? (
      <span
        style={{ cursor: "pointer" }}
        onClick={() => onLoanDetails(loanApplicationId)}
      >
        {link}
      </span>
    ) : null;
  };
  const onLoanDetails = async (loanApplicationId) => {
    // Get Loan Application Details
    const result = await apiHandler({
      url: endpoint.CUSTOMER_APPLICATIONFINDID + loanApplicationId,
      authToken: authToken,
    });
    // Loan Details Modal
    setLoanDetails(result.data);
    setShowLoanDetails(true);
  };
  const handleChange = (event, loanApplicationId) => {
    setSelectedAgent(event.target.value);
    let updatedSelectedAgents = selectedAgents;
    if (event.target.value === "me") {
      const agentdata = {
        id: userDetails.id,
        mobileNumber: userDetails.mobileNumber,
      };
      updatedSelectedAgents[loanApplicationId] = agentdata;
    } else {
      updatedSelectedAgents[loanApplicationId] = event.target.value;
    }

    setSelectedAgents(updatedSelectedAgents);
  };

  const AssignTaskToAgent = async (loanApplicationId) => {
    const selectedSclAgent = selectedAgents[loanApplicationId];
    if (!selectedSclAgent) {
      toastUpdate("Error", "Please select Agent first", true);
      return;
    }
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.ADMIN_APPLICANTIONASSIGN,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
        assigneeUserId: selectedSclAgent.id,
        assigneeUserMobileNumber: selectedSclAgent.mobileNumber,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code && res?.data?.error_code === 403) {
      toastUpdate("Error", res?.data?.user_description, true);
      return;
    } else if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return;
    } else {
      toastUpdate("Success", "Loan application is assigned to selected Agent", true);
      GetDashboardData();
    }
  };
  const createdFeildagent = (loanApplicationId, agentList) => {
    return (
      <>
        <Select
          labelId="demo-simple-select-placeholder-label-label"
          id={loanApplicationId.toString()}
          onChange={(event) => handleChange(event, loanApplicationId)}
          displayEmpty
          className={classes.selectText}
          style={{ width: 200 }}
        >
          <MenuItem value={"me"}>{"Assign to me"}</MenuItem>
        </Select>
      </>
    );
  };
  const getIcons = (loanApplicationId) => {
    return (
      <>
        <Button
          // size="small"
          // className={classes.nextButton1}
          // color="info"
          // className="bg-gradient-theme-left border-0"
          disabled={callInProgress}
          onClick={() => AssignTaskToAgent(loanApplicationId)}
          >
          Assign
        </Button>
        <Button
          size="small"
          // color="info"
          // className="bg-gradient-theme-left border-0"
          style={{ marginLeft: 0 }}
          onClick={() => RejectTaskToAgent(loanApplicationId)}
        >
          Reject
        </Button>
      </>
    );
  };
  const RejectTaskToAgent = (loanApplicationId) => {
    setShowLoanReject(true);
    setLoanReject(loanApplicationId);
  };
  const onSearchChange = (event) => {
    const filteredData = rawData.applications.filter((row) => {
      const val = event.target.value;
      return row.loanRequestNum.toLowerCase().includes(val.toLowerCase());
    });
    parseIndicatorData(
      { count: filteredData.length, applications: filteredData },
      completeAgentList
    );
  };


  useEffect(() => {
    if(!goldRate.length){
    GetData();}
  }, []);
  const GetData = async () => {
    const result = await apiHandler({
      url: endpoint.ADMIN_GOLDRATE_FINDALL,
      authToken: authToken,
    });
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setGoldRate(result.data);
    }
  };
  const enablePersoanLoan = parseAndSetFlag(featureFlags?.enablePersonalLoanFlag);
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label="My Dashboard"
          onSearchChange={onSearchChange}
          searchLabel="Search For Details"
          search
        />
      </Grid>
       {!enablePersoanLoan && <Grid item style={{ background: brandTheme.dashboardSliderColor, fontWeight:700,width:"900px"}} xs={12} sm={12} md={12}>
          <div>
            <Marquee gradient={false} className={classes.marqueContainer}>
              {goldRate?.map((item)=>(
                <span key={item.purity}>
                  <span style={{ padding: '0px 5px' }}>Gold: {item.purity}</span>
                  <span style={{ padding: '0px 5px' }}>{"\u20B9"}{`${item.lendingPrice} / ${"\u20B9"} ${(item.lendingPrice * 0.75)?.toFixed(2)}`}</span> 
                <span style={{ padding: '0px 15px' }}>|</span>
                </span>
              ))}
            </Marquee>
           </div>
        </Grid>}
        <Grid item xs={12} sm={12} md={12}>
        <ColumnGroupingTable columns={tableColumns} rows={selectedTableData} />
        </Grid>
        <LoanReject
          showModal={showLoanReject}
          trade={loanReject}
          closeModal={closeLoansModal}
        />
        {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
     {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
    </Grid>
  );
}
